import Calendar from './Calendar.view';

export default Calendar;
